import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunction } from '../../../common/core/global_function';
import { ForgotpasswordService } from 'app/common/services/forgotpassword.service';
import { API } from '../../../config/api';
import {RegisterService} from '../../../common/services/register.service';

@Component({
    selector: 'app-root',
    templateUrl: 'register.component.html',
})

export class RegisterComponent {
    email_label = "";
    public loading = false;
    constructor(private route: ActivatedRoute,
        private router: Router,
        public register_service: RegisterService) {

    }

    onInit() {
        document.title ='Sign Up';
    }

    back_link() {
        this.router.navigate(['/authenticate']);
    }
    register(){
      var that = this;
      if (this.register_service.validate()) {

      }
    }
}



// WEBPACK FOOTER //
// ./src/app/application/authenticate/signup/register.component.ts